// Refusal codes the App Server publishes for a credential write (/credentials, and relayed by /people).
export const CREDENTIAL_ERROR_CODE = {
	PASSCODE_IN_USE: 'PASSCODE_IN_USE',
	CARD_IN_USE: 'CARD_IN_USE',
	CARD_NAME_IN_USE: 'CARD_NAME_IN_USE',
	MOBILE_CREDENTIAL_NOT_EDITABLE: 'MOBILE_CREDENTIAL_NOT_EDITABLE',
	LOCK_FIRST_CREDENTIAL: 'LOCK_FIRST_CREDENTIAL'
};

// The one-line toast for each code; it replaces the server prose.
export const CREDENTIAL_ERROR_MESSAGE = {
	[CREDENTIAL_ERROR_CODE.PASSCODE_IN_USE]: 'That passcode is already in use. Use another one or generate one.',
	[CREDENTIAL_ERROR_CODE.CARD_IN_USE]: 'That card already exists. Assign it to a person instead of adding it again.',
	[CREDENTIAL_ERROR_CODE.CARD_NAME_IN_USE]: 'Another card already has that name. Use a different name.',
	[CREDENTIAL_ERROR_CODE.MOBILE_CREDENTIAL_NOT_EDITABLE]: 'Only the name of a mobile credential can be changed.',
	[CREDENTIAL_ERROR_CODE.LOCK_FIRST_CREDENTIAL]:
		'This card or PIN was added to the lock over Bluetooth. Remove it with the Zezamii Access app.'
};

// CARD_IN_USE on a card PATCH: the clash is the number in the new template, or the CSN.
export const CARD_IN_USE_ON_UPDATE_MESSAGE = {
	externalCredentialTemplateID: 'A card with this number already exists for this site code.',
	uniqueIdentifier: 'This CSN already exists.'
};

// Why a delivery row on GET /credentials/propagation failed (`errorCode`); null = see `status`.
export const DELIVERY_ERROR_CODE = {
	LOCK_UNSUPPORTED: 'LOCK_UNSUPPORTED', // the lock can't hold this credential (a PIN on a keypad-less lock)
	ATTEMPTS_EXHAUSTED: 'ATTEMPTS_EXHAUSTED' // the sweep spent its budget; a manual Retry resets it
};
